module.exports = __webpack_public_path__ + "img/katarina_outside_15.4b42758b.jpg";